//announce import
import announce_nanmai from './sound/announce/なんまいとれたかな.mp3';
import announce_mairimasu from './sound/announce/まいります.mp3';

//voice import
import voice_a from './sound/voice/あ.mp3';
import voice_i from './sound/voice/い.mp3';
import voice_u from './sound/voice/う.mp3';
import voice_e from './sound/voice/え.mp3';
import voice_o from './sound/voice/お.mp3';
import voice_ka from './sound/voice/か.mp3';
import voice_ki from './sound/voice/き.mp3';
import voice_ku from './sound/voice/く.mp3';
import voice_ke from './sound/voice/け.mp3';
import voice_ko from './sound/voice/こ.mp3';
import voice_sa from './sound/voice/さ.mp3';
import voice_si from './sound/voice/し.mp3';
import voice_su from './sound/voice/す.mp3';
import voice_se from './sound/voice/せ.mp3';
import voice_so from './sound/voice/そ.mp3';
import voice_ta from './sound/voice/た.mp3';
import voice_ti from './sound/voice/ち.mp3';
import voice_tu from './sound/voice/つ.mp3';
import voice_te from './sound/voice/て.mp3';
import voice_to from './sound/voice/と.mp3';
import voice_na from './sound/voice/な.mp3';
import voice_ni from './sound/voice/に.mp3';
import voice_nu from './sound/voice/ぬ.mp3';
import voice_ne from './sound/voice/ね.mp3';
import voice_no from './sound/voice/の.mp3';
import voice_ha from './sound/voice/は.mp3';
import voice_hi from './sound/voice/ひ.mp3';
import voice_hu from './sound/voice/ふ.mp3';
import voice_he from './sound/voice/へ.mp3';
import voice_ho from './sound/voice/ほ.mp3';
import voice_ma from './sound/voice/ま.mp3';
import voice_mi from './sound/voice/み.mp3';
import voice_mu from './sound/voice/む.mp3';
import voice_me from './sound/voice/め.mp3';
import voice_mo from './sound/voice/も.mp3';
import voice_ya from './sound/voice/や.mp3';
import voice_yu from './sound/voice/ゆ.mp3';
import voice_yo from './sound/voice/よ.mp3';
import voice_ra from './sound/voice/ら.mp3';
import voice_ri from './sound/voice/り.mp3';
import voice_ru from './sound/voice/る.mp3';
import voice_re from './sound/voice/れ.mp3';
import voice_ro from './sound/voice/ろ.mp3';
import voice_wa from './sound/voice/わ.mp3';

//effect import
import effect_cancel from './sound/effect/cancel.mp3';
import effect_decision from './sound/effect/decision.mp3';
import effect_select from './sound/effect/select.mp3';
import effect_taiko from './sound/effect/taiko.mp3';
import effect_taiko2 from './sound/effect/taiko2.mp3';

const AnnounceStore = {
    nanmai: announce_nanmai,
    mairimasu: announce_mairimasu
}

const VoiceStore = {
    a: voice_a,
    i: voice_i,
    u: voice_u,
    e: voice_e,
    o: voice_o,
    ka: voice_ka,
    ki: voice_ki,
    ku: voice_ku,
    ke: voice_ke,
    ko: voice_ko,
    sa: voice_sa,
    si: voice_si,
    su: voice_su,
    se: voice_se,
    so: voice_so,
    ta: voice_ta,
    ti: voice_ti,
    tu: voice_tu,
    te: voice_te,
    to: voice_to,
    na: voice_na,
    ni: voice_ni,
    nu: voice_nu,
    ne: voice_ne,
    no: voice_no,
    ha: voice_ha,
    hi: voice_hi,
    hu: voice_hu,
    he: voice_he,
    ho: voice_ho,
    ma: voice_ma,
    mi: voice_mi,
    mu: voice_mu,
    me: voice_me,
    mo: voice_mo,
    ya: voice_ya,
    yu: voice_yu,
    yo: voice_yo,
    ra: voice_ra,
    ri: voice_ri,
    ru: voice_ru,
    re: voice_re,
    ro: voice_ro,
    wa: voice_wa
}

const EffectStore = {
    cancel: effect_cancel,
    decision: effect_decision,
    select: effect_select,
    taiko2: effect_taiko2
}

class AnnouncePlayer {
    constructor() {
        this.onPlaying = false;
    }
    play(character) {
        return new Promise(resolve => {
            if (this.onPlaying) {
                this.playing.pause();
            }
            this.playing = new Audio(AnnounceStore[character]);
            this.playing.addEventListener('ended', () => {
                console.log(`ended: [${character}]`);
                this.onPlaying = false;
                resolve();
            });
            this.playing.play();
            this.onPlaying = true;
        });
    }
    stop() {
        if(typeof this.playing != "undefined"){
            this.playing.pause();
            this.playing.currentTime = 0;
        }
    }
}

function getRandom(min, max){
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}

class VoicePlayer {    
    constructor() {
        this.onPlaying = false;
    }
    static CARD = Object.keys(VoiceStore);
    setvoicetype(voiceType) {
        this.voiceType = voiceType;
    }
    select(character) {
        return new Promise(resolve => {
            if (this.onPlaying) {
                this.playing.pause();
            }
            this.playing = new Audio();
            
            console.log(`this.voiceType: [${this.voiceType}]`);
            if(this.voiceType == 'normal'){
                this.playing.defaultPlaybackRate = 1.0;
            } else {
                var rate = getRandom(1, 3);
                switch(rate){
                    case 1:
                        rate = 0.5;
                        break;
                    case 2:
                        rate = 2.2;
                        break;
                }
                this.playing.defaultPlaybackRate = rate;
            }
            console.log(`defaultPlaybackRate: [${this.playing.defaultPlaybackRate}]`);
            this.playing.src = VoiceStore[character];
            console.log(`character: [${character}]`);
            resolve();
        });
    }
    play(character) {
        return new Promise(resolve => {
            this.playing.addEventListener('ended', () => {
                this.onPlaying = false;
                resolve();
            });
            this.playing.src = VoiceStore[character];
            this.playing.play();
            this.onPlaying = true;
        });
    }
    replay() {
        this.playing.currentTime = 0;
        this.playing.play();
    }
    stop() {
        if(typeof this.playing != "undefined"){
            this.playing.pause();
            this.playing.currentTime = 0;
        }
    }
}

class EffectPlayer {
    constructor() {
        this.onPlaying = false;
    }
    play(character) {
        return new Promise(resolve => {
            if (this.onPlaying) {
                this.playing.pause();
            }
            this.playing = new Audio(EffectStore[character]);
            this.playing.addEventListener('ended', () => {
                console.log(`ended: [${character}]`);
                this.onPlaying = false;
                resolve();
            });
            this.playing.play();
            this.onPlaying = true;
        });
    }
    stop() {
        if(typeof this.playing != "undefined"){
            this.playing.pause();
            this.playing.currentTime = 0;
        }
    }
}

// module.exports = {AnnouncePlayer, VoicePlayer, EffectPlayer};
export {AnnouncePlayer, VoicePlayer, EffectPlayer};
